import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { useDropboxFolders } from '../../hooks/useDropboxFolders';
import FolderSelector from '../Common/FolderSelector';

interface MoveFolderModalProps {
  folder: any;
  onClose: () => void;
  onSuccess: () => void;
}

const MoveFolderModal: React.FC<MoveFolderModalProps> = ({ folder, onClose, onSuccess }) => {
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(folder.parent_id);
  const { moveFolderTo, loading } = useDropboxFolders();

  const handleMove = async () => {
    const result = await moveFolderTo(folder.id, selectedFolderId);
    if (result) {
      onSuccess();
      onClose();
    }
  };

  return (
    <Modal show={true} onHide={onClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Move Folder</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Move{' '}
          <strong 
            style={{ 
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              hyphens: 'auto'
            }}
            title={folder.name}
          >
            {folder.name}
          </strong>{' '}
          to:
        </p>
        <FolderSelector
          value={selectedFolderId}
          onChange={setSelectedFolderId}
          excludeFolderId={folder.id}
          disabled={loading}
          label="Destination Folder"
          placeholder="Search or select destination folder..."
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleMove} disabled={loading}>
          {loading ? 'Moving...' : 'Move'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MoveFolderModal;
